.backdrop {
  background: transparent;
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  // Above page-level sticky headers (e.g. the product-edit header at z-index 30)
  // so this top-bar overlay covers page content; still below the sidebar (50).
  z-index: 40;
}

.root {
  position: relative;
}

.trigger {
  border-radius: 999px;
  height: 44px;
  width: 44px;
}

.dropdown {
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  max-height: calc(100vh - 80px);
  min-width: 224px;
  overflow-y: auto;
  padding: 8px;
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  // Sit above the product-edit sticky header (z-index 30) and its own backdrop.
  z-index: 41;
}

.section {
  display: flex;
  flex-direction: column;

  & + & {
    border-top: 1px solid var(--color-border);
    margin-top: 6px;
    padding-top: 6px;
  }
}

.section-label {
  color: var(--color-muted-foreground);
  letter-spacing: 0.04em;
  padding: 6px 16px 4px;
  text-transform: uppercase;
}

.item {
  align-items: center;
  background: none;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  gap: 12px;
  padding: 10px 16px;
  text-align: left;
  width: 100%;

  &:hover {
    background: var(--color-secondary);
  }
}

.item-icon {
  color: var(--color-muted);
  flex-shrink: 0;
  height: 16px;
  width: 16px;
}
